import React, {useEffect} from 'react';
import styled from "styled-components";

import {useParams} from "react-router-dom";
import {apiEndPoints} from "../../api/network/apiEndPoints";
import {useDispatch, useSelector} from "react-redux";
import {HelmetProvider} from 'react-helmet-async'
import {fetchMediaDetail} from "../../api/redux/media";
import Details from "../../components/media/Details";
import GetInTouch from "../../components/GetInTouch";
import {Loading} from "../../components/Loading";
import Seo from "../../components/Seo";

const MyComponent = () => {

    const dispatch = useDispatch()
    const getData = useSelector(store => store.media)
    let {slug} = useParams();

    // api call
    useEffect(() => {
        let api_url = apiEndPoints.MEDIA_DETAIL
        dispatch(fetchMediaDetail([api_url + `/${slug}`]))
    }, [])


    useEffect(() => {
        window.scroll(0, 0)
    }, [])

    let meta =getData?.detail?.[0]?.meta;

    return (

        <HelmetProvider>
            <Seo
                title={`${meta?.meta_title ? meta?.meta_title : getData?.detail?.[0]?.post_title} | UCC`}
                description={meta?.meta_desc}
                image={getData?.detail?.[0]?.image}
                type="article"
            />

            <StyledComponent>
                {/*{getData?.detailLoading && <Loading/>}*/}
                <Details data={getData}/>
                <GetInTouch data={getData?.detail?.[0]?.footer_top}/>
            </StyledComponent>
        </HelmetProvider>

    );
};

const StyledComponent = styled.section`

`;

export default MyComponent;
